module.exports = __webpack_public_path__ + "media/images/business/img-feature-jobpage-d4a81af700fd67007d62fbaf5b891896.png";